import { useStore } from '@hooks/useStore';
import { useMyTranslations } from '@hooks/useMyTranslations';
import { useGetBrandData } from '@hooks/useGetBrandData';
import { PageHeader } from '@components/Core/PageHeader';
import { AppLoader } from '@components/Core/AppLoader';
import ProductForm from '@forms/ProductForm';
import { ProductsTransFields } from '@pages/Products/types';
import { productsTranslations } from '@pages/Products/translations';

function AddProduct() {
  const {
    brandsStore: { brand },
  } = useStore();

  const { t } = useMyTranslations<Extract<ProductsTransFields, 'addProduct'>>([
    productsTranslations.name,
  ]);

  const { isFetching, text } = useGetBrandData(t('addProduct', { ns: productsTranslations.name }));

  return (
    <div className="page-container">
      <PageHeader text={text} />
      {isFetching ? <AppLoader /> : brand && <ProductForm brandId={brand.id} />}
    </div>
  );
}

export default AddProduct;
